module.exports = __webpack_public_path__ + "static/media/exel.39f35216.svg";